import React, { useEffect, useMemo, useState, useRef } from 'react';
import { withRouter } from 'react-router-dom';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Card, CardBody, Col, Container, Row, Button, Label, CardText, CardTitle, ButtonGroup, Input, Modal } from 'reactstrap';
import notify from '../../../custom/helpers/Notify';
import '../../../pages/Tables/datatables.scss';
import { ActionButtons } from '../../../custom/components/ActionButtons';
import { ConfirmDialog } from '../../../custom/components/ConfirmDialog';
import { pageState, lastAPIActionTimeState, pageWebsocketsEnabledState, themeTypeState, leftSidebarTypeState, themeDirection } from '../../../state/GlobalState';
import { HasPermission } from '../../../custom/helpers/HasPermission';
import { DynamicModal } from '../../../custom/components/DynamicModal';
import { cloneDeep, get, set } from 'lodash';
import Flatpickr from "react-flatpickr"
import Select from "react-select"
import "flatpickr/dist/themes/material_blue.css"
import { formModes, userFilterState, modalConfigDefault, userDataStructureState as dataStructureState, userListState as dataListState, userRoleState, userModuleState, userServiceCategoryState, userLocationState } from './state'; // CHANGE
import { getDataListRequest, partialUpdateRequest as updateDataRequest, deleteDataRequest, resetPasswordRequest, getRoleListRequest, isDisplayedRequest, grantModuleRequest, rejectModuleRequest, getModuleListRequest, findDataRequest, getServiceCatgegoryListRequest, getLocationListRequest } from '../../../api/controller/UserController'; // CHANGE
import { Loader } from '../../../custom/components/Loader';
import echo from '../../../api/core/echo';
import { handleSocket, handleGridSocket } from '../../../custom/helpers/HandleSocket';
import { AgGridReact } from "ag-grid-react"
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine-dark.css';
import { handleResponse } from '../../../custom/helpers/HandleResponse';
import SelectEditor from "../../../custom/components/grid/SelectEditor"
import DefaultEditor from "../../../custom/components/grid/DefaultEditor"
import MaskEditor from "../../../custom/components/grid/MaskEditor"
import DateTimeEditor from "../../../custom/components/grid/DateTimeEditor"
import RadioEditor from "../../../custom/components/grid/RadioEditor"
import CheckboxEditor from "../../../custom/components/grid/CheckboxEditor"
import SwitchEditor from "../../../custom/components/grid/SwitchEditor"
import moment from 'moment';
import useBreakpoint from '../../../custom/components/hooks/useBreakpoint';
import { STORAGE_PUBLIC_BASE } from '../../../custom/helpers/storagePublicBase';

const Users = () => {

  const model = 'User' // CHANGE
  const models = 'Users' // CHANGE
  
  // GET & SET SELECTS
  const selects = [ // CHANGE
    { model: 'Role', getFn: getRoleListRequest, setFn: useSetRecoilState(userRoleState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
    { model: 'Module', getFn: getModuleListRequest, setFn: useSetRecoilState(userModuleState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
    { model: 'ServiceCategory', getFn: getServiceCatgegoryListRequest, setFn: useSetRecoilState(userServiceCategoryState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
    { model: 'Location', getFn: getLocationListRequest, setFn: useSetRecoilState(userLocationState), ref: useRef([]), keys: { label: 'name', value: 'id' } },
  ]

  const [partialUpdating, setPartialUpdating] = useState(false)
  const dir = useRecoilValue(themeDirection)

  const defaultColDef = {
    sortable: true,
    editable: true,
    valueSetter: async(e) => {
      setPartialUpdating(true)
      let tempRow = { id: e.data.id }
      let s = ['select','multiselect']
      dataStructure.filter(i=>i.table?.editable).forEach((input) => {        
        let v = e.newValue
        if((e.column.colDef?.cellEditorParams?.fieldName || e.column.colId) !== getFN(input)){
          if(Array.isArray(e.data[getFN(input)])){
            v = e.data[getFN(input)].map(i=>s.includes(input.type) ? (i[input.subFields?.value || "id"] || i) : i)
          } else if(s.includes(input.type)){
            v = e.data[getFN(input)][input.subFields?.value || "id"] || e.data[getFN(input)]
          } else if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(e.data[getFN(input)]).format(input.table?.postDateFormat)
          } else {
            v = e.data[getFN(input)]
          }
        } else {
          if(input.type === 'datepicker' && input.table?.postDateFormat){
            v = moment(v).format(input.table?.postDateFormat)
          }
        }
        tempRow = {...tempRow, [getPN(input)]: v }
      })
      const response = await updateDataRequest({...tempRow})
      handleResponse(response)
      setPartialUpdating(false)
    },
  }
  
  const [ovf, _setOvf] = useState(false);
  const ovfRef = useRef(ovf);
  const setOvf = data => {
    ovfRef.current = data;
    _setOvf(data);
  }
  const [dataList, setDataList] = useRecoilState(dataListState);
  // eslint-disable-next-line
  const [gridColumnApi, setGridColumnApi] = useState(null);
  const [gridApi, _setGridApi] = useState(null);
  const gridApiRef = useRef(gridApi)
  const setGridApi = data => {
    gridApiRef.current = data;
    _setGridApi(data)
  }
  const [pageWebsocketsEnabled, setPageWebsocketsEnabled] = useRecoilState(pageWebsocketsEnabledState)
  const setPage = useSetRecoilState(pageState)
  const [lastAPIActionTime, setLastAPIActionTime] = useRecoilState(lastAPIActionTimeState)
  const [tableLoading, setTableLoading] = useState(true)
  const [findLoading, setFindLoading] = useState(false)
  const themeType = useRecoilValue(themeTypeState)
  const [mobileSearchFilter, setMobileSearchFilter] = useState('')	
  const [searchValue, setSearchValue] = useState('')	
  const searchValueRef = useRef(searchValue)
	
  const [confirmModalVisible, setConfirmModalVisible] = useState(false)
  const [confirmID, setConfirmID] = useState(null);
  const [confirmParams, setConfirmParams] = useState({});
  const [confirmConfig, setConfirmConfig] = useState({ fn: null, title: null, body: null });
  const [cuModalConfig, _setCUModalConfig] = useState({visible: false, header: model, type: null, typeKey: null, data: {}, ...modalConfigDefault})
  const cuModalConfigRef = useRef(cuModalConfig)
  const setCUModalConfig = data => {
    cuModalConfigRef.current = data;
    _setCUModalConfig(data)
  }
  const [actionsDisabled, setActionsDisabled] = useState(true)
  const [primaryChannel, setPrimaryChannel] = useState(null)
  const [filters, setFilters] = useRecoilState(userFilterState)
  const dataStructure = useRecoilValue(dataStructureState)
  const [selectedRow, setSelectedRow] = useState(null)
  
  const breakPoint = useBreakpoint()
    const [xsFData, _setXsFData] = useState([])
  const xsFDataRef = useRef(xsFData)
  const setXsFData = data => {
    xsFDataRef.current = data;
    _setXsFData(data)
  }
  const [xsPageSize] = useState(10)
  const [xsCurrentPage, setXsCurrentPage] = useState(1)
  const [xsMaxPage, setXsMaxPage] = useState(1)
  
  const [moduleManagerVisible, setModuleManagerVisible] = useState(false)
  const [moduleManagerUser, setModuleManagerUser] = useState(null)
  const [moduleManagerBtnDisabled, setModuleManagerBtnDisabled] = useState(false)

  const [profileViewerVisible, setProfileViewerVisible] = useState(false)
  const [profileViewerUser, setProfileViewerUser] = useState(null)

  const modules = useRecoilValue(userModuleState)

  const leftSidebarType = useRecoilValue(leftSidebarTypeState)

  useEffect(() => {
    if(gridApi){
      gridApi.sizeColumnsToFit()
    }
    // eslint-disable-next-line
  }, [leftSidebarType])

  useEffect(() => {
    setPage((models.charAt(0).toLowerCase() + models.slice(1)).split(" ").join("")) // CHANGE
    setPageWebsocketsEnabled(process.env.REACT_APP_WEBSOCKETS_ENABLED === 'true') // CHANGE
  }, [setPage, setPageWebsocketsEnabled])

  useEffect(() => {
    async function fetchData(filter){
      setTableLoading(true)	
      setDataList([])	
      const response = await getDataListRequest(filter);	
      if(response && response.Status !== 'error'){	
        setDataList(response.data)	
        response.ovf ? setOvf(true) : setOvf(false)	
      } else {	
        notify({ status: 'error', message: response.Message })	
      }	
      searchValueRef.current = searchValue;	
      setTableLoading(false)
    }
    let fetch = true
    let postData = {}
    if(filters.length > 0){
      filters.forEach((filter)=>{
        fetch = filter.value.length === 0 && filter.required ? false : fetch
        if(filter.value){
          set(postData, filter.name || filter.label.replace(/ /g, ''), filter.type === "select" ? filter.value.value : filter.value)
        }
      })	
    }	
    if(ovf){	
      set(postData, 'SearchQuery', searchValue)	
    }	
    if(fetch){	
      fetchData(postData)	
    }
    if(pageWebsocketsEnabled){
      const channelFilters = Object.keys(postData).filter((k)=>k !== "SearchQuery").length > 0 ? "." + Object.keys(postData).filter((k)=>k !== "SearchQuery").map((val)=>(postData[val].toString())).join(".") : ""
      const channelToSub = `${model.replace(/ /g, '')}-Primary${channelFilters}`
      if(primaryChannel !== channelToSub){
        if(primaryChannel){
          echo.leave(primaryChannel)
        }
        setPrimaryChannel(channelToSub)
        echo.private(channelToSub).listen(`.${model.replace(/ /g, '')}Events`, (data) => {
          if(gridApiRef.current){
            handleGridSocket(data, gridApiRef.current, setGridApi, (ovfRef.current ? isDisplayedRequest : false), searchValueRef.current)
          } else {
            handleSocket(xsFDataRef.current, data, setXsFData)
          }
          if(data.from !== echo.socketId() && cuModalConfigRef.current.visible === true && cuModalConfigRef.current.type === "Update" && parseInt(cuModalConfigRef.current.data.id) === parseInt(data.data.id) && data.event === "Updated"){
            setCUModalConfig({...cuModalConfigRef.current, expired: true})
          }
        });
      }
    }
    // eslint-disable-next-line
  }, [lastAPIActionTime, filters, pageWebsocketsEnabled]);

  useEffect(() => {
    async function fetchSelectData(){
      setActionsDisabled(true)
      await Promise.all(selects.map(async(select)=>{
        if(! (select.persist && select.read?.length > 0)){
          const response = await select.getFn();
          const setFnRef = data => {
            select.ref.current = data
            select.setFn(data)
          }
          if(select.wsEnabled){
            echo.private(`${select.model}-Select`).listen(`.${select.model}Events`, (data) => {
              handleSocket(select.ref.current, data, setFnRef, select.keys || { label: "name", value: "id" })
            });
          }
          if(response && response.Status !== 'error'){	
            setFnRef({ ovf: response.ovf, data: (select.exactValue ? response.data : response.data?.map((val)=>({ label: val[select.keys.label || "name"], value: val[select.keys.value || "id"] }))) })	
          } else {	
            notify({ status: 'error', message: response.Message });	
          }
        }
      }))
      setActionsDisabled(false)
    }
    fetchSelectData();
    return () => {
      setDataList([])
      if(pageWebsocketsEnabled){
        echo.leave(primaryChannel)
      }
      selects.filter(s=>!(s.persist && s.read?.length > 0)).forEach((s)=>{
        s.ref.current = []
        s.setFn([])
        if(s.wsEnabled){
          echo.leave(`${s.model}-Select`)
        }
      })
    }
    // eslint-disable-next-line
  }, [])

  const findFn = async(row, find) => {
    if(find && !row.___complete___){
      setFindLoading(true)
      const response = await find({id: row.id})
      if(response && response.data){
        row = response.data
        row.___complete___ = true
        if(gridApiRef.current){
          gridApiRef.current.getRowNode(row.id).setData(row)
          if(gridApiRef.current && gridApiRef.current.getSelectedNodes() && gridApiRef.current.getSelectedNodes()[0]){
              gridApiRef.current.getSelectedNodes()[0].setSelected(false)
              setTimeout(()=>{
                  gridApiRef.current.getRowNode(row.id).setSelected(true)
              }, [50])
          }
        } else {
          setXsFData(xsFDataRef.current.map((val)=>row.id === val.id ? row : val))
        }
      } else {
        handleResponse(response)
        row = false
      }
      setTimeout(() => setFindLoading(false), 250)
    }
    return row
  }
  
  const toggleCUModal = async({row={}, find=false, mode=null, modeKey=0, size=null, wizard=null}) => {
    if(row){
      row = await findFn(row, find)
      setCUModalConfig({ ...cuModalConfig, visible: !cuModalConfig.visible, type: typeof(mode) === 'string' ? mode : null, typeKey: modeKey, data: row, size: size || cuModalConfig.size, wizard: wizard !== null ? wizard : cuModalConfig.wizard })
    }
  }

  const toggleConfirmModal = ({row={}, params={}, request=null, title=null, body=null}) => {
    setConfirmID(row ? row.id : null)
    setConfirmParams(params)
    setConfirmConfig({ fn: request, title: title, body: body })
    setConfirmModalVisible(! confirmModalVisible)
  }

  const toggleModuleManager = async({row=null, find=false}) => {
    if(row){
      row = await findFn(row, find)
      setModuleManagerUser(row)
    } else {
      setModuleManagerUser(null)
    }
    setModuleManagerVisible(!moduleManagerVisible)
  }

  const toggleProfileViewer = async({row={}, find=false}) => {
    if(row){
      row = await findFn(row, find)
      setProfileViewerUser(row)
    } else {
      setProfileViewerUser(null)
    }
    setProfileViewerVisible(!profileViewerVisible)
  }

  const getPN = (val) => {
    return val.name || val.label.replace(/ /g, '')
  }
  
  const getFN = (val) => {
    return val.field || val.label.replace(/ /g, '_').toLowerCase()
  }


  const actionListLocation = 'top' // inline
  const actionListType = 'menu' // menu
  const xsActionListType = 'menu' // menu
  const xsActions = useMemo(() => ([
    {
      label: 'View',
      permission: 'read',
      icon: 'mdi mdi-eye',
      color: 'primary',
      fn: toggleCUModal,
      params: { mode: "View", size: "lg", find: findDataRequest }
    },
    {
      label: 'View Profile',
      permission: 'read',
      icon: 'mdi mdi-account',
      color: 'primary',
      fn: toggleProfileViewer,
      params: { find: findDataRequest }
    },
    {
      label: 'Manage Modules',
      permission: 'manageModule',
      icon: 'mdi mdi-cog',
      color: 'warning',
      fn: toggleModuleManager,
      params: { find: findDataRequest }
    },
    {
      label: 'Update',
      permission: 'update',
      icon: 'mdi mdi-pencil',
      color: 'success',
      fn: toggleCUModal,
      params: { mode: "Update", find: findDataRequest }
    },
    {
      label: 'Reset',
      permission: 'update',
      icon: 'mdi mdi-refresh',
      color: 'info',
      fn: toggleConfirmModal,
      params: { request: resetPasswordRequest, title: 'Are you sure', body: 'you want to reset password?' }
    },
    {
      label: 'Delete',
      permission: 'delete',
      icon: 'mdi mdi-trash-can',
      color: 'danger',
      fn: toggleConfirmModal,
      params: { request: deleteDataRequest }
    },
    // eslint-disable-next-line
  ]), []);

  // eslint-disable-next-line
  const actions = useMemo(() => xsActions, [xsActions])

  const renderActions = (row, grouped=false, actionList=false) => <ActionButtons key={row.id} actions={(actionList ? actionList : actions)} type={grouped ? xsActionListType : actionListType} row={row} grouped={grouped} />

  const valueGetter = (data, input) => {
    let d = get(data, getFN(input))
    if(input.type === 'checkbox'){
      return (parseInt(d) === 1 || d === true) ? "Yes" : ((parseInt(d) === 0 || d === false) ? "No" : "")	
    } else if(input.type === 'switch'){
      return (parseInt(d) === 1 || d === true) ? (input.list && input.list[0] ? input.list[0] : "Yes") : ((parseInt(d) === 0 || d === false) ? (input.list && input.list[1] ? input.list[1] : "No") : "")
    } else if((input.type === 'select' || input.type === 'multiselect' || input.type === 'nestedselect') && !input.rootValue){
      return d ? d[input.subFields?.label || "name"] : ""
    } else if(input.type === 'datepicker' && input.table?.dateFormat){
      return d ? moment(d).format(input.table.dateFormat) : null
    } else {
      return d
    }
  }

  const cellEditor = (type) => {
    switch(type){
      case 'checkbox':
        return 'CheckboxEditor'
      case 'switch':
        return 'SwitchEditor'
      case 'datepicker':
        return 'DateTimeEditor'
      case 'select':
        return 'SelectEditor'
      case 'multiselect':
        return 'SelectEditor'
      case 'mask':
        return 'MaskEditor'
      case 'radio':
        return 'RadioEditor'
      default:
        return 'DefaultEditor'
    }
  }

  // Default Selected Values as of now are set in Cell Editors by searching via label displayed on table
  let columns = useMemo(() => {
    return [...dataStructure.filter((val) => val.order?.table).sort((a,b)=>(a.order?.table > b.order?.table ? 1 : -1)).map((val) => (
        {
          headerName: val.tableHeader || val.label, 
          field: ((val.field || val.label.replace(/ /g, '_').toLowerCase()).replace(/\./g, '') + (val.subFields || (val.type === "select" && !val.rootValue) ? val.subFields?.label || val.subFields?.name || "name" : "" )).replace(/\./g, ''),
          filter: val.type === 'number' ? 'agNumberColumnFilter' : (val.type === 'datepicker' ? 'agDateColumnFilter' : 'agTextColumnFilter'),
          editable: val.table?.editable || false,
          cellEditor: cellEditor(val.type),
          cellEditorPopup: val.type === 'checkbox' || val.type === 'select' || val.type === 'multiselect' || val.type === 'radio',
          valueGetter: (params) => valueGetter(params?.data || params, val),
          cellEditorParams: (params) => ({
            fieldName: getFN(val),
            values: val.type === 'datepicker' ? {
                options: val.table?.options,
                value: params.data[getFN(val)]
              } : val.type === 'select' || val.type === 'multiselect' || val.type === 'radio' ? {
                list: val.list,
                getRequest: val.getRequest,
                creatable: ((val.type === 'select' || val.type === 'multiselect') && val.table?.creatable) || false,
                type: val.type,
                rootValue: val.rootValue,
                subFields: val.subFields,
              } : val.type === 'mask' ? {
                mask: val.table?.mask
              } : val.type === 'switch' ? {
                list: val.list,
              } : {
                type: val.type
              }
            
          }),
          maxWidth: val.table?.maxWidth || null,
          minWidth: val.table?.minWidth || null,
        }
      )),
      actionListLocation === 'inline' && !(breakPoint === 'xs' || breakPoint === 'sm') ? ({
        headerName: "Actions",
        cellRendererFramework: (params) => renderActions(params?.data || params),
        maxWidth: 200
      }) : null
      
    ].filter(i=>i!==null)
    // eslint-disable-next-line
  }, [dataStructure])

  useEffect(() => {
    if(gridApi){
      gridApi.sizeColumnsToFit()
    }
    // eslint-disable-next-line
  }, [columns])

  const data = dataList?.map((row) => {
    let tempRow = cloneDeep(row)
    dataStructure.filter((input) => input.order?.table).forEach((input) => {
      const field = input.subFields || (input.type === "select" && !input.rootValue) ? (input.subFields?.label || input.subFields?.name || input.type === "select" ? ((input.field || input.label.replace(/ /g, '_').toLowerCase()) + "." + (input.subFields?.label || input.subFields?.name || "name")) : (input.field || input.label.replace(/ /g, '_').toLowerCase())) : (input.field || input.label.replace(/ /g, '_').toLowerCase());
      let temp = get(tempRow,field)
      if(! (temp === false || temp === 0)){
        temp = temp || input.tableDefault || ""
      }
      set(tempRow, field.replace(/\./g, ''), temp)
    })
    return tempRow
  })

  
  // specify the data
  const onGridReady = (params) => {
    setGridApi(params.api);
    setGridColumnApi(params.columnApi);
    if(params.api){
      params.api.sizeColumnsToFit();
      window.addEventListener('resize', function () {
        setTimeout(function () {
          params.api.sizeColumnsToFit();
        });
      });
      params.api.sizeColumnsToFit();
    }
  };

  useEffect(() => {	
    if(! ovf){	
      setXsFData(data.filter(item=>{	
        let match = true	
        if(mobileSearchFilter.length > 0){	
          let filters = mobileSearchFilter.split(" ")	
          filters.filter(f=>f.length > 0).forEach(filter=>{	
            let innerMatch = false	
            columns.forEach((column)=>{	
              if(String(column.valueGetter(item)).toLowerCase().indexOf(String(filter).toLowerCase()) >= 0){	
                innerMatch = true	
              }	
            })	
            if(! innerMatch){	
              match = false	
            }	
          })	
        }	
        return match	
      }))	
    } else {	
      setXsFData(data)	
    }	
    // eslint-disable-next-line	
  }, [dataList, mobileSearchFilter])	
  useEffect(() => {	
    if(! ovf){	
      setSearchValue(mobileSearchFilter)	
    }	
    // eslint-disable-next-line
  }, [mobileSearchFilter])

  useEffect(()=>{
    let maxPages = Math.ceil(xsFData.length / xsPageSize)
    if(maxPages !== xsMaxPage){
      setXsCurrentPage(1)
    }
    setXsMaxPage(maxPages)
    // eslint-disable-next-line
  }, [xsFData])

  const moduleAction = async(user, module, action="DENY") => {
    setModuleManagerBtnDisabled(true)
    let response = null
    if(action === "DENY"){
      response = await rejectModuleRequest({id: user.id, Module: module.id})
      if(response && response.Status === "success"){
        moduleManagerUser?.module_requests?.splice(moduleManagerUser?.module_requests?.findIndex(i=>i.id === module.id), 1)
        moduleManagerUser?.modules?.splice(moduleManagerUser?.modules?.findIndex(i=>i.id === module.id), 1)
      }
    } else if(action === "GRANT") {
      response = await grantModuleRequest({id: user.id, Module: module.id})
      if(response && response.Status === "success"){
        moduleManagerUser?.module_requests?.splice(moduleManagerUser?.module_requests?.findIndex(i=>i.id === module.id), 1)
        moduleManagerUser?.modules?.push(module)
      }
    }
    setModuleManagerBtnDisabled(false)
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Loader loading={partialUpdating} transparent />
          <Row>
            <Col xs={12} md={4}>
              <h3>
                {models}{" "}
                  {HasPermission("create") ? (
                    <Button disabled={actionsDisabled} color='primary' className='ml-2 waves-effect waves-light' type='submit' onClick={() => toggleCUModal({ mode: "Create" })}>
                      <i className='mdi mdi-plus d-block font-size-12'></i>
                    </Button>
                  ) : null}
                </h3>
            </Col>
            <Col xs={12} md={8} align="right">
              {filters && filters.length > 0 ? (
                <Row>
                  {filters.map((filter, key)=>(
                    <Col key={key} xs={12} md={filter.size || 6} className={filter.offset ? `offset-md-${filter.offset}` : ''}>
                      <Row>
                        <Col className="d-none d-md-block mt-2" xs={12} md={3} align={dir === "rtl" ? "left" : "right"}>
                          <Label>{filter.label}</Label>
                        </Col>
                        <Col className="d-block d-md-none mt-2" xs={12} md={3} align={dir === "rtl" ? "right" : "left"}>
                          <Label>{filter.label}</Label>
                        </Col>
                        <Col xs={12} md={9} align={dir === "rtl" ? "right" : "left"}>
                        {filter.type === "date" ? (
                            <Flatpickr onChange={(_,e) => setFilters({filterLabel: filter.label, value: e})} placeholder="Select..." options={{ altInput: true, defaultDate: filter.value }} value={filter.value} className="form-control d-block" />
                          ) : null}
                          {filter.type === "dateRange" ? (
                            <Flatpickr onChange={(_,e) => (e.split(" to ").length > 1) ? setFilters({filterLabel: filter.label, value: (e.split(" to "))}) : false} placeholder="Select..." options={{ mode:'range', altInput: true, defaultDate: filter.value }} value={filter.value} className="form-control d-block" />
                          ) : null}
                          {filter.type === "select" ? (
                            <Select onChange={(e) => setFilters({filterLabel: filter.label, value: e})} placeholder="Select..." options={filter.list?.data} value={filter.value} />
                          ) : null}
                        </Col>
                      </Row>
                    </Col>
                  ))}                  
                </Row>
              ) : null}
            </Col>
          </Row>
          <Row>
            <Col className="col-12">
              {!(breakPoint === 'xs' || breakPoint === 'sm') ? (
                <Card className='d-none d-md-block'>
                  <CardBody>
                    <Loader loading={tableLoading} />
                    <Loader loading={findLoading} transparent />
                    <Row>
                      <Col xs={6}>
                        <div style={{display: 'flex', justifyContent: dir === "rtl" ? "right" : "left"}}>	
                          <input value={searchValue} onKeyPress={(e)=>{	
                            if(e.key === 'Enter' && ovf){	
                              setLastAPIActionTime(new Date())	
                            }	
                          }} type="text" className="form-control" onChange={(e)=>{	
                            if(!ovf){	
                              gridApi.setQuickFilter(e.target.value);	
                              setGridApi(gridApi)	
                            }	
                            setSearchValue(e.target.value)	
                          }} placeholder="Search..." style={{ maxWidth:"400px", marginBottom:"15px" }} />	
                          {ovf ? (	
                            <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>Search All</Button></>	
                          ) : null}	
                        </div>
                      </Col>
                      <Col xs={6}>
                        <div style={{display: 'flex', justifyContent: dir === "rtl" ? "left" : "right"}}>
                          {selectedRow && actionListLocation !== 'inline' ? (
                            <React.Fragment>
                              {renderActions(selectedRow?.data)}&nbsp;&nbsp;
                              <Button disabled={actionsDisabled} color='info' className='btn-sm waves-effect waves-light' style={{marginLeft:'5px'}} type='submit' onClick={()=>{
                                if(gridApi.getSelectedNodes().length > 0){
                                  gridApi.getSelectedNodes()[0].setSelected(false)
                                }
                              }}>
                                <i className='mdi mdi-close d-block font-size-12'></i>
                              </Button>
                            </React.Fragment>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div className={themeType === 'dark' ? "ag-theme-alpine-dark" : "ag-theme-alpine"} style={{height: '650px'}}>
                        <AgGridReact
                            frameworkComponents={{
                              renderActions: renderActions,
                              SelectEditor: SelectEditor,
                              DefaultEditor: DefaultEditor,
                              MaskEditor: MaskEditor,
                              DateTimeEditor: DateTimeEditor,
                              RadioEditor: RadioEditor,
                              CheckboxEditor: CheckboxEditor,
                              SwitchEditor: SwitchEditor,
                            }}
                            // editType="fullRow"
                            onSelectionChanged={()=>{
                              setSelectedRow(gridApi.getSelectedNodes()[0] || false)
                            }}
                            enableCellTextSelection={true}
                            defaultColDef={defaultColDef}
                            onGridReady={onGridReady}
                            rowHeight={55}
                            rowStyle={{border: 'none'}}
                            animateRows={true}
                            pagination={true}
                            paginationPageSize={10}
                            rowData={data} 
                            getRowNodeId={(data)=>data.id}
                            columnDefs={columns}
                            rowSelection="single"
                          >
                        </AgGridReact>
                    </div>
                  </CardBody>
                </Card>
              ) : (
                <div className="d-block d-md-none mt-2">
                  <Loader loading={tableLoading} />
                  <Loader loading={findLoading} transparent />
                  <div className="d-block d-md-none" style={{display: 'flex', justifyContent: 'left'}}>	
                    <div style={{display: 'flex', justifyContent: 'left'}}>	
                      <input value={mobileSearchFilter} type="text" className="form-control" onKeyPress={(e)=>{	
                          if(e.key === 'Enter' && ovf){	
                            setLastAPIActionTime(new Date())	
                          }	
                        }} onChange={(e)=>{	
                          setMobileSearchFilter(e.target.value)	
                        }} placeholder="Search..." style={{ maxWidth:"315px", marginBottom:"15px" }} />	
                        {ovf ? (	
                          <>&nbsp;&nbsp;&nbsp;<Button style={{maxHeight:'38px', minWidth:'58px'}} color='primary' className='btn-sm waves-effect waves-light' onClick={()=>setLastAPIActionTime(new Date())}>Search</Button></>	
                        ) : null}	
                    </div>	
                  </div>
                  {xsFData.slice(((xsCurrentPage-1) * xsPageSize), (xsCurrentPage * xsPageSize)).map((item, key)=>(
                    <Card key={key} className='border border-primary'>
                        <CardTitle className='text-center bg-primary pt-2 pb-2 text-white'>{item[columns[0]?.field]}</CardTitle>
                        <CardBody className='pt-0 pb-0'>
                          {columns.map((column, ck) => (
                            ck > 0 ? <CardText key={ck} className="mb-2"><span style={{fontWeight:600}}>{column.headerName}: </span><span className={themeType === 'dark' ? 'text-white' : 'text-primary'}>{column.valueGetter(item)}</span></CardText> : null
                          ))}
                        </CardBody>
                      <ButtonGroup>
                        {dataList.length > 0 ? renderActions(item, true, xsActions) : null}
                      </ButtonGroup>
                    </Card>
                  ))}
                  <ButtonGroup style={{display:"flex"}}>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage(1)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-left d-block font-size-16'></i>
                    </Button>
                    <Button disabled={xsCurrentPage <= 1} onClick={()=>setXsCurrentPage((c)=>--c)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-left d-block font-size-16'></i>
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <Input style={{maxWidth:"50px"}} type="text" value={xsCurrentPage} onClick={(e)=>e.target.setSelectionRange(0, e.target.value.length)} onChange={(e)=>{
                        if(parseInt(e.target.value) > 0 && parseInt(e.target.value) <= xsMaxPage){
                          e.target.blur()
                          setXsCurrentPage(parseInt(e.target.value))
                        }
                      }} />
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light'>
                      of
                    </Button>
                    <Button color='info' className='btn-md waves-effect waves-light'>
                      {xsMaxPage}
                    </Button>

                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage((c)=>++c)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-right d-block font-size-16'></i>
                    </Button>
                    <Button disabled={xsCurrentPage >= xsMaxPage} onClick={()=>setXsCurrentPage(xsMaxPage)} color='info' className='btn-md waves-effect waves-light' style={{marginLeft:'2px'}}>
                      <i className='mdi mdi-chevron-double-right d-block font-size-16'></i>
                    </Button>
                  </ButtonGroup>
                </div>
              )}
            </Col>
          </Row>

          <DynamicModal config={cuModalConfig} toggleModal={toggleCUModal} submitModes={formModes} ds={dataStructure} />

          <ConfirmDialog id={confirmID} params={confirmParams} config={confirmConfig} visible={confirmModalVisible} toggleModal={toggleConfirmModal} />

          <Modal size="lg" isOpen={moduleManagerVisible} toggle={()=>toggleModuleManager({})} keyboard={false} backdrop="static">
              <div className="modal-header">
                <h4 className="modal-title mt-0" id="myModalLabel">Manage Modules - {moduleManagerUser?.display_name}</h4>
                <button type="button" onClick={() => toggleModuleManager({})} className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <React.Fragment>
                  <div className="modal-body">
                      <h5 className="mt-0">Requested Modules</h5>
                      {moduleManagerUser?.module_requests?.length > 0 ? (
                        <>
                          {moduleManagerUser?.module_requests?.map((item, key)=>(
                            <Card key={key} className='border mb-1'>
                              <CardBody>
                                <Row>
                                  <Col xs={9}>
                                    <h4><b className="mb-0">{item.name}</b></h4>
                                  </Col>
                                  <Col xs={3}>
                                    <ButtonGroup>
                                      <Button color="success" disabled={moduleManagerBtnDisabled} onClick={()=>moduleAction(moduleManagerUser, item, "GRANT")}>Grant</Button>&nbsp;
                                      <Button color="danger" disabled={moduleManagerBtnDisabled} onClick={()=>moduleAction(moduleManagerUser, item, "DENY")}>Deny</Button>
                                    </ButtonGroup>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          ))}
                        </>
                      ) : <p className="text-muted">- No Requested Modules -</p>}
                      <br /><hr /><br />
                      <h5 className="mt-0">Granted Modules</h5>
                      {moduleManagerUser?.modules?.length > 0 ? (
                        <>
                          {moduleManagerUser?.modules?.map((item, key)=>(
                            <Card key={key} className='border mb-1'>
                              <CardBody>
                                <Row>
                                  <Col xs={9}>
                                    <h4><b className="mb-0">{item.name}</b></h4>
                                  </Col>
                                  <Col xs={3}>
                                    <ButtonGroup>
                                      {item.type !== "Public" && <Button color="danger" disabled={moduleManagerBtnDisabled} onClick={()=>moduleAction(moduleManagerUser, item, "DENY")}>Revoke</Button>}
                                    </ButtonGroup>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          ))}
                        </>
                      ) : <p className="text-muted">- No Granted Modules -</p>}
                      <br /><hr /><br />
                      <h5 className="mt-0">Other Modules</h5>
                      {modules?.data?.filter(i=>(
                        moduleManagerUser?.modules?.filter(j=>(j.id === i.value)).length === 0 && moduleManagerUser?.module_requests?.filter(j=>(j.id === i.value)).length === 0
                      )).length > 0 ? (
                        <>
                          {modules?.data?.filter(i=>(
                            moduleManagerUser?.modules?.filter(j=>(j.id === i.value)).length === 0 && moduleManagerUser?.module_requests?.filter(j=>(j.id === i.value)).length === 0
                          )).map((item, key)=>(
                            <Card key={key} className='border mb-1'>
                              <CardBody>
                                <Row>
                                  <Col xs={9}>
                                    <h4><b className="mb-0">{item.label}</b></h4>
                                  </Col>
                                  <Col xs={3}>
                                    <ButtonGroup>
                                      <Button color="success" disabled={moduleManagerBtnDisabled} onClick={()=>moduleAction(moduleManagerUser, {...item, id: item.value, name: item.label}, "GRANT")}>Grant</Button>&nbsp;
                                    </ButtonGroup>
                                  </Col>
                                </Row>
                              </CardBody>
                            </Card>
                          ))}
                        </>
                      ) : <p className="text-muted">- No Other Modules -</p>}
                  </div>
                  <div className="modal-footer">
                    <button type="button" onClick={() => toggleModuleManager({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
                  </div>               
              </React.Fragment>
          </Modal>



          <Modal size="lg" isOpen={profileViewerVisible} toggle={()=>toggleProfileViewer({})} keyboard={false} backdrop="static">
              <div className="modal-header">
                <h4 className="modal-title mt-0" id="myModalLabel">Company Profile - {profileViewerUser?.display_name}</h4>
                <button type="button" onClick={() => toggleProfileViewer({})} className="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <React.Fragment>
                  <div className="modal-body">
                      {profileViewerUser ? (
                        <React.Fragment>


                        
                        {/*------------------------------------------------Modal body start---------------------------------------------*/}

                        <h4 className='mt-3 mb-3'>Company Profile info</h4>
                          <Row>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Label><b>Company Name</b></Label>
                                <p>{profileViewerUser?.company?.legal_name}</p>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Label><b>Business Type</b></Label>
                                <p>{profileViewerUser?.company?.business_type}</p>
                            </Col>
                            
                          </Row>
                         
                          <Row className='mt-3 mb-3'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Label><b>Company Address</b></Label>
                                {profileViewerUser?.company?.addresses?.map((address,key)=><p key={key}>{address.display_name}</p>)}
                            </Col>
                          </Row>
                          
                          <Row className='mt-2 mb-2'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Label><strong>Company Contacts</strong></Label>
                                <p>{profileViewerUser?.company?.contact_numbers?.map((contact,key)=>(key === 0 ? '' : ' / ') + contact.contact_number)}</p>
                            </Col>
                          </Row>

                          <Row className='mt-2 mb-2'>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <Label><b>Company Emails</b></Label>
                                <p>{profileViewerUser?.company?.emails?.map((email,key)=>(key === 0 ? '' : ' / ') + email.email)}</p>
                            </Col>
                          </Row>

                          <hr/>
                          <h4 className='mt-3 mb-3'>Company Documents</h4>
                          <Row>
                            
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Business permit</b></Label>
                                <p>
                                  {profileViewerUser?.company?.business_permit_authorization ? <a href={STORAGE_PUBLIC_BASE + profileViewerUser?.company?.business_permit_authorization} target="_blank" rel="noopener noreferrer">View</a> : "- No File -"}
                                </p>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Company registration</b></Label>
                                <p>
                                  {profileViewerUser?.company?.company_registration ? <a href={STORAGE_PUBLIC_BASE + profileViewerUser?.company?.company_registration} target="_blank" rel="noopener noreferrer">View</a> : "- No File -"}
                                </p>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Incumbency certificate</b></Label>
                                <p>
                                  {profileViewerUser?.company?.incumbency_certificate ? <a href={STORAGE_PUBLIC_BASE + profileViewerUser?.company?.incumbency_certificate} target="_blank" rel="noopener noreferrer">View</a> : "- No File -"}
                                </p>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Profile sheet</b></Label>
                                <p>
                                  {profileViewerUser?.company?.profile_sheet ? <a href={STORAGE_PUBLIC_BASE + profileViewerUser?.company?.profile_sheet} target="_blank" rel="noopener noreferrer">View</a> : "- No File -"}
                                </p>
                            </Col>
                            <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Tax registration certificate</b></Label>
                                <p>
                                  {profileViewerUser?.company?.tax_registration_certificate ? <a href={STORAGE_PUBLIC_BASE + profileViewerUser?.company?.tax_registration_certificate} target="_blank" rel="noopener noreferrer">View</a> : "- No File -"}
                                </p>
                            </Col>
                          </Row>
                          <hr/>
                          <h4 className='mt-3 mb-3'> Registration Info</h4>
                          <Row>
                            <Col xs={12} sm={6} md={3} lg={4}>
                                <Label><b>Registration number</b></Label>
                                <p>{profileViewerUser?.company?.registration_number}</p>
                            </Col>
                            <Col xs={12} sm={6} md={3} lg={4}>
                                <Label><b>Registered country</b></Label>
                                <p>{profileViewerUser?.company?.registered_country}</p>
                            </Col>
                            <Col xs={12} sm={6} md={3} lg={4}>
                                <Label><b>Tax Registration Number</b></Label>
                                <p>{profileViewerUser?.company?.tax_registration_numbers}</p>
                            </Col>
                           
                          </Row>
                          <hr/>
                          <h4 className='mt-3 mb-3'> Representative Info</h4>
                          <Row>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Label><b>Representative name</b></Label>
                                <p>{profileViewerUser?.company?.representative_name}</p>
                            </Col>
                            <Col xs={12} sm={6} md={6} lg={6}>
                                <Label><b>Representative designation</b></Label>
                                <p>{profileViewerUser?.company?.representative_designation}</p>
                            </Col>
                           
                          </Row>
                          <hr/>
                          <h4 className='mt-3 mb-3'> Years Of services</h4>
                          <Row>
                          <Col xs={12} sm={6} md={4} lg={4}>
                                <Label><b>Years of incorporation</b></Label>
                                <p>{profileViewerUser?.company?.year_of_incorporation}</p>
                          </Col>
                          <Col xs={12} sm={6} md={4} lg={3}>
                                <Label><b>Years establised internationally</b></Label>
                                <p>{profileViewerUser?.company?.years_established_internationally}</p>
                          </Col>
                          <Col xs={12} sm={6} md={3} lg={4}>
                                <Label><b>Years established locally</b></Label>
                                <p>{profileViewerUser?.company?.years_established_locally}</p>
                          </Col>
                          </Row>

                          <hr/>
                        <Row>
                          <Col xs={12} sm={12} md={12} lg={12} >
                            <div>
                            <Label><b>Company Website</b></Label>
                              <p>{profileViewerUser?.company?.website}</p>
                            </div>
                     
                          </Col>
                        </Row>

                        {/*--------------------------------------------Modal body end-------------------------------------------------------*/}
                        </React.Fragment>
                      ) : null}
                  </div>
                  <div className="modal-footer">
                    <button type="button" onClick={() => toggleProfileViewer({})} className="btn btn-secondary waves-effect" data-dismiss="modal">Close</button>
                  </div>               
              </React.Fragment>
          </Modal>



        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(Users);
